import { FC } from "react";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter, RatingFilter as RatingFilterEnum } from "constants/filters";

import { FilterValues, IFilterConfig, IFilterUpdate } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getItems = (filterConfig: IFilterConfig, filterValues: string[]) => {
  const isAnySet = (filterValues || []).includes(RatingFilterEnum.Rated);
  const isNoneSet = (filterValues || []).includes(RatingFilterEnum.NotRated);

  return filterConfig.filterLabels?.map(labelItem => ({
    key: labelItem.value,
    name: labelItem.label,
    disabled:
      (isAnySet || isNoneSet) &&
      ![RatingFilterEnum.Rated, RatingFilterEnum.NotRated].includes(labelItem.value as RatingFilterEnum),
  }));
};

interface IProps {
  filterValues: string[];
  filterConfig: IFilterConfig;
  onChange(filterUpdate: IFilterUpdate<FilterValues>): void;
}

const RatingFilter: FC<IProps> = props => {
  const { filterConfig, filterValues, onChange } = props;
  const items = getItems(filterConfig, filterValues) || [];
  const selected = items?.filter(item => filterValues?.includes(item.key));

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleChange = (selectedItems: IPickerListItem[] | null) => {
    const values = selectedItems && selectedItems.map(item => item.key as RatingFilterEnum);
    let filterValues: string[] | null = null;
    if (values?.includes(RatingFilterEnum.Rated || RatingFilterEnum.NotRated)) {
      filterValues = values.filter(value => !selected?.map(item => item.key).includes(value));
    } else if (!selectedItems?.length) {
      filterValues = null;
    } else {
      filterValues = values;
    }

    onChange({
      name: Filter.Rating,
      value: filterValues,
    });
  };

  return (
    <Picker
      type="multi"
      id="rating-filter"
      options={items}
      onSelect={handleChange}
      placeholder="Select"
      openedOnInit
      selected={selected}
      hideClearButton
      searchDisabled
    />
  );
};

export default withFilterBase(RatingFilter);
